export const routes = (prefix = `finance-dashboard`) => [
    // {
    //     path: `/${prefix}/cashsales/transactions/print`,
    //     name: `${prefix}.coas.transactions.print`,
    //     component: () => import('./tabs/transactions/Print.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         permissions: {
    //             PageName: `${prefix}.coas.index`,
    //             PageDescription: "Finance: COAS",
    //         },
    //     },
    // },
    
    {
        path: `/${prefix}/cashsales`,
        name: `${prefix}.cashsales.index`,
        component: () => import('./Index.vue'),
        meta: {
            requiresAuth: true,
            permissions: {
                PageName: `${prefix}.cashsales.index`,
                PageDescription: "Finance: Define Tax Cash Sales",
            },
        },
    }
    // , {
    //     path: `/${prefix}/coas/journalentries`,
    //     name: `${prefix}.coas.journalentries`,
    //     component: () => import('./JournalEntries.vue'),
    //     meta: {
    //         requiresAuth: true,
    //         permissions: {
    //             PageName: `${prefix}.coas.journalentries`,
    //             PageDescription: "Finance: Journal Entries",
    //         },
    //     },
    // }
    ,
];